import done from './done.svg';
import doneD from './done';

const state = {
	done,
	doneD,
};

export default state;
